﻿export function getEpiData(name, rootId) {
    let root = document.getElementById(rootId);
    return root.getAttribute(`data-lf-epi-${name}`);
}

export function getEpiDataFromElement(name, element) {
    return element.getAttribute(`data-lf-epi-${name}`);
}